import { useGetFrontRichieste } from '@framework/api-client/api/inquiries-compile/richieste-controller/richieste-controller.ts';
import { type GetFrontRichiesteParams } from '@framework/api-client/api/inquiries-compile/schemas/getFrontRichiesteParams.ts';
import { SubmissionLogic } from '@framework/frontoffice-submission/submission/SubmissionLogic.ts';
import { useMemo } from 'react';

/**
 * Richieste presentate nella pratica, recuperate in base alla query.
 */
export function useDossierSubmissions(query: GetFrontRichiesteParams) {
  const { data, isLoading, isFetching, error } = useGetFrontRichieste(query, {
    query: { keepPreviousData: true },
    request: { arrayFormat: 'repeat' },
  });

  // Mantiene in `datiTitolari` solo i soggetti di tipo Titolare
  const submissions = useMemo(
    () => SubmissionLogic.filterSubmissionsApplicantData(data?.dati),
    [data?.dati],
  );

  return { submissions, isLoading, isFetching, error };
}
